var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M8.075,28.306A15,15,0,0,1,15,0a1.088,1.088,0,0,1,0,2.175A12.825,12.825,0,1,0,27.824,15h0a12.773,12.773,0,0,0-2.19-7.169l-1.206,1.05a1.085,1.085,0,0,1-1.1.2,1.088,1.088,0,0,1-.692-.878l-.622-4.86A1.086,1.086,0,0,1,23.38,2.153l4.725,1.293a1.087,1.087,0,0,1,.426,1.869L27.288,6.4A15,15,0,0,1,8.075,28.306Zm4.218-7.156a1.055,1.055,0,0,1-.78-.3,1.088,1.088,0,0,1-.3-.751,1.489,1.489,0,0,1,.509-1.049l2.61-2.461a14.391,14.391,0,0,0,1.8-2.01,3.355,3.355,0,0,0,.69-1.98,1.578,1.578,0,0,0-.6-1.35,1.946,1.946,0,0,0-1.29-.48,2.162,2.162,0,0,0-1.26.419,1.916,1.916,0,0,0-.75,1.26.861.861,0,0,1-.36.6,1.212,1.212,0,0,1-.63.18,1.032,1.032,0,0,1-.661-.24.727.727,0,0,1-.27-.66,3.028,3.028,0,0,1,.661-1.83,3.821,3.821,0,0,1,1.53-1.111A4.839,4.839,0,0,1,15.083,9a4.49,4.49,0,0,1,1.859.39,3.347,3.347,0,0,1,1.41,1.17,3.139,3.139,0,0,1,.57,1.95,4.959,4.959,0,0,1-.39,1.8A7.049,7.049,0,0,1,17,16.44l-2.37,2.34c-.14.139-.191.27-.15.39.04.1.16.15.36.15h3.39a.955.955,0,0,1,.75.27.836.836,0,0,1,.27.66.8.8,0,0,1-.9.9Z",
    transform: "translate(0)",
    fill: "#fafbfd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackword);
export default __webpack_public_path__ + "static/media/backword.c5824a5674a5c752d088b71d75827ed2.svg";
export { ForwardRef as ReactComponent };